import * as THREE from 'three';
import { Panel } from '../ui/panel';
import { acquireMenuPointer, releaseMenuPointer } from '../ui/pointer';
import { placePanelInFront } from '../ui/placement';
import { t } from '../i18n';
import { PAUSE_PANEL_HEIGHT_M, PAUSE_PANEL_WIDTH_M } from '../config/constants';

export type PausePanelHandlers = {
  onResume: () => void;
  onEnd: () => void;
};

export class PausePanel {
  private panel: Panel | null = null;

  constructor(
    private scene: THREE.Scene,
    private camera: THREE.Camera,
  ) {}

  show(handlers: PausePanelHandlers): void {
    if (this.panel) return;
    const panel = new Panel({ widthM: PAUSE_PANEL_WIDTH_M, heightM: PAUSE_PANEL_HEIGHT_M });
    const cw = panel.canvas.width;
    const ch = panel.canvas.height;

    panel.setButtons([
      {
        rect: { x: cw * 0.12, y: ch * 0.55, w: cw * 0.36, h: ch * 0.3 },
        label: t('resume'),
        variant: 'primary',
        onClick: () => {
          this.hide();
          handlers.onResume();
        },
      },
      {
        rect: { x: cw * 0.52, y: ch * 0.55, w: cw * 0.36, h: ch * 0.3 },
        label: t('endSession'),
        variant: 'secondary',
        onClick: () => {
          this.hide();
          handlers.onEnd();
        },
      },
    ]);
    panel.render(t('paused'), '');

    placePanelInFront(panel.mesh, this.camera);
    this.scene.add(panel.mesh);
    this.panel = panel;
    acquireMenuPointer();
  }

  hide(): void {
    if (!this.panel) return;
    releaseMenuPointer();
    this.scene.remove(this.panel.mesh);
    this.panel.dispose();
    this.panel = null;
  }

  isVisible(): boolean {
    return this.panel !== null;
  }
}
